import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const supabase = defineConnector({
  identifier: "supabase",
  name: "Supabase",
  tagLine: "Backend as a service",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  defaultUrlPattern: () => "https://.*\\.supabase\\.co/.*",
  auth: (app) =>
    headerAuth([
      { name: "apikey", value: app.secret.serviceRoleKey },
      {
        name: "Authorization",
        value: app.secret.serviceRoleKey,
        scheme: "Bearer",
      },
    ]),
  steps: [
    {
      title: "Get your Supabase project details",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Supabase Dashboard](https://supabase.com/dashboard/projects) and select your project.\n\nGo to **Settings** → **API** to find your project URL and API keys.",
        },
      ],
    },
    {
      title: "Enter your Supabase credentials",
      items: [
        {
          kind: "hostname",
          label: "Project URL",
          placeholder: "xxxxx.supabase.co",
          required: true,
          target: { kind: "configuration", field: "projectUrl" },
          helperText: "Your Supabase project URL",
        },
        {
          kind: "input",
          label: "Service role key",
          placeholder: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
          required: true,
          target: { kind: "secrets", field: "serviceRoleKey" },
          helperText:
            "Use the service_role key for full access, or anon key for public access only.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ projectUrl }) => `https://${projectUrl}/rest/v1/`,
  },
  publicEnvVars: ({ projectUrl }) => ({
    SUPABASE_URL: projectUrl ? `https://${projectUrl}` : "",
  }),
});
